import React, { useEffect, useState } from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PropTypes from 'prop-types';

const Picture = ({Img}) => {
    const [lazy,setLazy] = useState(true);

    useEffect(() => {
        const img = new Image();
        img.src = Img;
        img.onload = () => {
            if(lazy) setLazy(prevState => !prevState);
        }
    },[Img])

    return ( 
        <>
            {lazy ? (<div className='w-100 h-100 text-center'>
            <img className='w-25 m-auto' src='../assets/images/Eclipse-loading.gif' alt="loading"/>
            <p>لطفا منتظر بمانید...</p>
            </div>) : (
                <div className='w-100 position-relative' style={{height:'98%'}}>
                    <TransformWrapper panning maxScale={2} disablePadding>
                        <TransformComponent>
                            <img src={Img} alt="test"/>
                        </TransformComponent>
                    </TransformWrapper>
                </div>
            )}
        </>
    );
}
 
export default Picture;

//TODO: propTypes
Picture.propTypes = {
    Img : PropTypes.string
}